import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PaymentReportsLayer from "../components/PaymentReportsLayer";

const PaymentReportsPage = () => {
    return (
        <MasterLayout>
            <PaymentReportsLayer />
        </MasterLayout>
    );
};

export default PaymentReportsPage;
